import { VIcon, BigVIcon, XIcon, BigXIcon } from "./Icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { ReactElement } from "react";

type PlayerData = {
  nickname?: string;
  diceResults: string[];
  lockedDice: boolean[];
  removedDice: boolean[];
};

type DiceRollerProps = {
  playerId: string;
  roomId: string;
  data: PlayerData;
  isOwner: boolean;
};

export default function DiceRoller({ playerId, roomId, data, isOwner }: DiceRollerProps) {
  const { diceResults, lockedDice, removedDice } = data;

  const dieFaces = ["v", "v", "V", "x", "x", "x", "x", "X"];
  const rollSingleDie = () =>
    dieFaces[Math.floor(Math.random() * dieFaces.length)];

  const activeDiceCount = 6 - removedDice.filter(Boolean).length;
  const hasTransformableX = diceResults.some(
    (d, i) => (d === "x" || d === "X") && !lockedDice[i] && !removedDice[i]
  );

  const playerRef = doc(db, "rooms", roomId, "players", playerId);

  const updateDice = (newData: Partial<PlayerData>) => {
    if (!isOwner) return;
    updateDoc(playerRef, newData);
  };

  const rollDice = (keepLocked = true) => {
    updateDice({
      diceResults: diceResults.map((val, i) => {
        if (removedDice[i]) return val;
        if (keepLocked && lockedDice[i]) return val;
        return rollSingleDie();
      }),
    });
  };

  const toggleLockDie = (index: number) => {
    updateDice({
      lockedDice: lockedDice.map((locked, i) =>
        i === index ? !locked : locked
      ),
    });
  };

  const toggleRemoveDie = (index: number) => {
    updateDice({
      lockedDice: lockedDice.map((locked, i) =>
        i === index ? false : locked
      ),
      removedDice: removedDice.map((removed, i) =>
        i === index ? !removed : removed
      ),
    });
  };

  const transformXtoV = () => {
    const index = diceResults.findIndex(
      (d, i) => (d === "x" || d === "X") && !lockedDice[i] && !removedDice[i]
    );
    if (index !== -1) {
      updateDice({
        diceResults: diceResults.map((val, i) =>
          i === index ? "v" : val
        ),
      });
    }
  };

  const resetAllDice = () => {
    updateDice({
      diceResults: Array(6).fill(null).map(() => rollSingleDie()),
      lockedDice: Array(6).fill(false),
      removedDice: Array(6).fill(false),
    });
  };

  const iconMap: Record<string, ReactElement> = {
    V: <BigVIcon />,
    v: <VIcon />,
    X: <BigXIcon />,
    x: <XIcon />,
  };

return (
  <div className="dice-roller">

    <section className="dice-area">
      {diceResults.map((val, i) => (
        <div
          key={i}
          className="dice"
          style={{
            opacity: removedDice[i] ? 0.3 : 1,
            border: lockedDice[i] ? "2px solid gold" : "2px solid white",
          }}
          onClick={() => isOwner && toggleRemoveDie(i)}
        >
          {val ? iconMap[val] : "?"}

          {isOwner && (
            <button
              className="buttoninterno"
              onClick={(e) => {
                e.stopPropagation();
                toggleLockDie(i);
              }}
            >
              BLOCCA
            </button>
          )}
        </div>
      ))}
    </section>

    {isOwner && (
      <div className="actions">
        <button onClick={resetAllDice}>
          NUOVO TIRO
        </button>

        <button
          onClick={() => rollDice()}
          disabled={activeDiceCount === 0}
        >
          USA ABILITÀ
        </button>

        <button
          onClick={transformXtoV}
          disabled={!hasTransformableX}
        >
          USA SICUREZZA
        </button>
      </div>
    )}

  </div>

  );

}